import React from 'react'
import {
    imageProgresses,
} from 'helperFunctions/uploadService';
import AlertDialog from 'components/Dialog/alertDialog';
import LinearProgressWithLabel from 'components/LinearProgressWithLabel';
import styles from './styles.module.scss';



interface UploadProgressProps {
    isOpen: boolean;
    imagesProgresses: { [x: string]: imageProgresses };
    handleDismiss: () => void;
}


const UploadProgressModal: React.FC<UploadProgressProps> = (props) => {
    return (
        <AlertDialog
            hasActions={false}
            handleClose={props.handleDismiss}
            buttonText="close"
            isOpen={props.isOpen}  
            title="Upload"
            content={() => {
                return (
                    <div className={styles.container}>
                        {
                            Object.keys(props.imagesProgresses).map((imageProgress) => {
                                return (
                                    <div className={styles.container}>
                                        <div className={styles.imageProgressContainer}>
                                            <img className={styles.image} src={URL.createObjectURL(props.imagesProgresses[imageProgress].file)} />
                                            <p>{imageProgress}</p>
                                        </div>
                                        <LinearProgressWithLabel value={props.imagesProgresses[imageProgress].percentCompleted} />
                                    </div>
                                )
                            })
                        }
                    </div>
                )
            }}
        />
    )
}

export default UploadProgressModal;
